<template>
  <b-col cols="12" md="10" class="mt-3 mb-3">
    <div class="speaker-single mb-0 bg-green pb-4 pr-4 pl-4">
      <b-row
        no-gutters
        class="justify-content-md-center d-flex justify-content-center"
      >
        <div class="col-md-3 col-sm-12 text-center mt-1">
          <img
            class="mt-5 speaker-image"
            :src="addToUrl(speaker.speakerImageURL, cloudinaryParams)"
            alt=""
          />
        </div>

        <div class="col-md-9 col-sm-12">
          <div class="p-0 p-md-3 pb-md-4 bg-green text-dark mt-3">
            <h5 class="pb-2">
              {{ speaker.speakerFirstName }}
              {{ speaker.speakerLastName }} |
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1687168589/2023_web/workshops/bx_calendar.svg"
                alt="calendar icon"
                class="mb-2"
              />
              {{ speaker.date }}
            </h5>

            <h5>{{ speaker.workshopName }}</h5>

            <ul class="text-left">
              <li
                v-for="(info, index) in speaker.info"
                :key="index"
                :style="speaker.numeralList ? 'list-style: none;' : ''"
              >
                <span v-if="speaker.numeralList"> {{ index + 1 + ")" }}</span>
                {{ info }}
              </li>
            </ul>
          </div>
        </div>
      </b-row>
    </div>
  </b-col>
</template>


<script>
export default {
  props: ["speaker"],
  data() {
    return {
      cloudinaryParams:
        "g_face,r_max,c_thumb,w_170,h_170,e_grayscale,b_rgb:69AFAB/",
    };
  },
  methods: {
    addToUrl(url, stringToAdd) {
      if (!url) {
        return;
      }
      const array = url.split("upload/");
      array.splice(1, 0, "upload/" + stringToAdd + "/");
      const urlString = array.join("");

      return urlString;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

h2,
h3,
h4,
h5 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

h5 {
  font-family: "Verdana";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
}

@media (min-width: 1500px) {
  .speaker-single {
    margin: 0 10rem 0 10rem !important;
  }
}
@media (max-width: 100px) {
  .speaker-single {
    margin: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/WorkshopSpeakerExtended.vue